import React from "react";
import "./style.scss";

interface Props {
    text: string;
}

/**
 * This component renders string content text.
 */

export const CollapsibleText = ({ text }: Props) => {
    const [showFullText, setShowFullText] = React.useState(false);
    const classNames = ["collapsibleText"];
    const buttonText = showFullText ? "Weniger lesen" : "Mehr lesen";

    if (showFullText) {
        classNames.push("open");
    }

    const handleOnClick = (): void => {
        setTimeout(() => setShowFullText(!showFullText), 200);
    };

    return (
        <div className={classNames.join(" ")}>
            <p>{text}</p>
            <a onClick={handleOnClick} className="toggleFullText">
                {buttonText}
            </a>
        </div>
    );
};
